









































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

export interface PatientInfo {
  fullName: string;
  phone: string;
  dob: string;
  recordId: string;
}

export interface DocumentItem {
  id: string;
  name: string;
  size: string;
  uploadDate: string;
  fileType: 'pdf' | 'image' | 'doc' | 'default';
  downloadUrl: string;
  storageId: string;
}

@Component
export default class DocumentList extends Vue {
  @Prop({ type: String, default: 'Medical Specialty Center' }) readonly officeName!: string;
  @Prop({ type: String, default: 'https://via.placeholder.com/150x50?text=Clinic+Logo' }) readonly officeLogo!: string;
  @Prop({ type: Boolean, default: false }) readonly isExpired!: boolean;

  @Prop({ 
    type: Object, 
    default: () => ({
      fullName: 'Jane Doe',
      phone: '+1 (555) 019-2834',
      dob: 'Oct 14, 1988',
      recordId: 'GAP-82910'
    }) 
  }) 
  readonly patient!: PatientInfo;

  @Prop({ type: Array, default: () => [] }) 
  readonly documents!: DocumentItem[];

  private loading: boolean = false;
  private downloadingId: string | null = null;
  private wmLogoUrl: string = require('@/assets/wmpc_logo.svg');

  mounted(): void {
    if (!this.isExpired) {
      this.logPageView();
    }
  }

  getFileIcon(fileType: DocumentItem['fileType']): string {
    switch (fileType) {
      case 'pdf': return 'far fa-file-pdf text-danger';
      case 'image': return 'far fa-file-image text-info';
      case 'doc': return 'far fa-file-word text-primary';
      default: return 'far fa-file-alt text-secondary';
    }
  }

  getIconBgClass(fileType: DocumentItem['fileType']): string {
    switch (fileType) {
      case 'pdf': return 'bg-danger-light';
      case 'image': return 'bg-info-light';
      case 'doc': return 'bg-primary-light';
      default: return 'bg-light';
    }
  }

  private logPageView(): void {
    this.$emit('log-event', {
      action: 'GAP_PAGE_VIEWED',
      patientId: this.patient.recordId,
      timestamp: new Date().toISOString()
    });
  }

  async downloadDocument(doc: DocumentItem): Promise<void> {
    this.downloadingId = doc.id;

    try {
      const { recordId } = this.patient;
      const gapId = Number((recordId || "").replace(/\D/g, ""));
      const { storageId } = doc;
      const { uri } = await this.$store.dispatch("gaps/getPatientFileDownloadUrl", {
        gapId,
        storageId,
      });
      window.location.href = uri;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }

    setTimeout(() => {
      this.$emit('log-event', {
        action: 'GAP_FILE_DOWNLOADED',
        patientId: this.patient.recordId,
        fileId: doc.id,
        fileName: doc.name,
        timestamp: new Date().toISOString()
      });

      this.downloadingId = null;
    }, 1000);
  }

  handleLogout(): void {
    this.$emit('logout');
  }

  handleContactSupport(): void {
    this.$emit('contact-support');
  }

  onLogoError(e: Event): void {
    const target = e.target as HTMLImageElement;
    target.src = 'https://via.placeholder.com/150x50?text=Clinic+Logo';
  }
}
